document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('.play-button-gallery');

    buttons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Récupérer l'URL de la vidéo
            var videoUrl = button.getAttribute('data-video');

            // Créer l'élément vidéo
            var videoElement = document.createElement('video');
            videoElement.setAttribute('controls', '');

            var sourceElement = document.createElement('source');
            sourceElement.setAttribute('src', videoUrl);
            sourceElement.setAttribute('type', 'video/mp4');
            
            videoElement.appendChild(sourceElement);
            
            // Insérer l'élément vidéo avant le bouton
            button.parentNode.insertBefore(videoElement, button);

            // Jouer la vidéo
            videoElement.play();

            // Cacher le bouton play
            button.style.display = 'none';

            // Gérer l'événement "ended"
            videoElement.addEventListener('ended', function() {
                videoElement.remove(); // Supprimez la vidéo du DOM
                button.style.display = 'flex'; // Montrer le bouton play
            });
        });
    });
});
